module.exports = __webpack_public_path__ + "img/perforaciones_3-4_1536.0eaca65d.jpg";